import 'slick-carousel/slick/slick'

export default class FeaturedStoriesSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-featured-stories-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            this.settings.$slider.slick({
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                appendDots: $('.js-ft-slider-dots'),
                prevArrow: $('.js-ft-slider-previous'),
                nextArrow: $('.js-ft-slider-next'),

                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            arrows: false,
                        }
                    },
                ]
            });
        }

    }

};

new FeaturedStoriesSlider();